import Vue from 'vue'
import qs from 'qs'
/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== "string") {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
export const getStore = (name) => {
    if (!name) return;
    return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
export const removeStore = (name) => {
    if (!name) return;
    window.localStorage.removeItem(name);
};

/**
 * 生成随机字符串(可指定长度)
 * @param len
 * @returns {string}
 */
export const randomString = (len) => {
    len = len || 8;
    let $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    let maxPos = $chars.length;
    let pwd = "";
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
};

/**
 * 获取url后参数
 */
export const GetRequest = () => {
    let url = location.search; //获取url中"?"符后的字串
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
        let str = url.substr(1);
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
    }
    return theRequest;
};

/**
 * 参数字符串
 * @param {*} str
 */
export const GetParam = (str) => {
    let theRequest = new Object();
    if (str.indexOf("?") != -1) {
        let newStr = str.slice(str.indexOf("?") + 1);
        let strs = newStr.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
    }
    return theRequest;
};

/**
 * 判断微信浏览器
 * @returns {Boolean}
 */
export const isWeiXin = () => {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
};

/**
 * 写cookies
 */
export const setCookie = (name, value, time) => {
    let strsec = getsec(time);
    let exp = new Date();
    exp.setTime(exp.getTime() + strsec * 1);
    document.cookie =
        name + "=" + escape(value) + ";expires=" + exp.toGMTString();
};

/**
 * 读取cookies
 */
export const getCookie = (name) => {
    let arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) return arr[2];
    else return null;
};

/**
 * 删除cookies
 */
export const delCookie = (name) => {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

/**
 * 浏览器判断
 * 用法示例——多套页面判断是否显示移动端：
 *   let ua = parseUA();
 *   if (!ua.mobile) {
 *       location.href = './pc.html';
 *   }
 */
export const parseUA = () => {
    let u = navigator.userAgent;
    let u2 = navigator.userAgent.toLowerCase();
    return {
        //移动终端浏览器版本信息
        trident: u.indexOf("Trident") > -1,
        //IE内核
        presto: u.indexOf("Presto") > -1,
        //opera内核
        webKit: u.indexOf("AppleWebKit") > -1,
        //苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
        //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),
        //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        //ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
        //android终端或uc浏览器
        iPhone: u.indexOf("iPhone") > -1,
        //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1,
        //是否iPad
        webApp: u.indexOf("Safari") == -1,
        //是否web应该程序，没有头部与底部
        iosv: u.substr(u.indexOf("iPhone OS") + 9, 3),
        weixin: u2.match(/MicroMessenger/i) == "micromessenger",
        ali: u.indexOf("AliApp") > -1,
    };
};

/**
 * 生成UUID
 * @returns {string}
 */
export const generateUUID = () => {
    let d = new Date().getTime();
    let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === "x" ? r : (r & 0x7) | 0x8).toString(16);
        }
    );
    return uuid;
};

/**
 * 删除左右两端的空格
 * @param str
 * @returns {string | * | void}
 */
function trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
}

/**
 * 删除左边的空格
 * @param str
 * @returns {string | * | void}
 */
function ltrim(str) {
    return str.replace(/(^\s*)/g, "");
}

/**
 * 删除右边的空格
 * @param str
 * @returns {string | * | void}
 */
function rtrim(str) {
    return str.replace(/(\s*$)/g, "");
}

/**
 * 判断当前网络环境
 */
export const isWifi = () => {
    try {
        let wifi = true;
        let ua = window.navigator.userAgent;
        let con = window.navigator.connection;
        // 如果是微信
        if (/MicroMessenger/.test(ua)) {
            if (ua.indexOf("WIFI") >= 0) {
                return true;
            } else {
                wifi = false;
            }
            // 如果支持navigator.connection
        } else if (con) {
            let network = con.type;
            if (
                network !== "wifi" &&
                network !== "2" &&
                network !== "unknown"
            ) {
                wifi = false;
            }
        }
        return wifi;
    } catch (e) {
        return false;
    }
};

/**
 * 首字母大写
 * @param str
 * @returns {string}
 */
export const fistLetterUpper = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * 过滤非法字符串
 */
export const illegalFilter = (str) => {
    let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
    let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

    if (regEn.test(str) || regCn.test(str)) return false;
    return true;
};
/**
 * 获取元素到达顶部的距离
 * @param {*} elements 需要计算的元素
 * @returns
 */
export const offsetTop = (elements) => {
    let top = elements.offsetTop;
    let parent = elements.offsetParent;
    while (parent != null) {
        top += parent.offsetTop;
        parent = parent.offsetParent;
    }
    return top;
};
/**
 * 获取元素到达左侧的距离
 * @param {*} elements 需要计算的元素
 * @returns
 */
export const offsetLeft = (elements) => {
    let left = elements.offsetLeft;
    let parent = elements.offsetParent;
    while (parent != null) {
        left += parent.offsetLeft;
        parent = parent.offsetParent;
    }
    return left;
};

//将base64转换为blob
export const dataURLtoBlob = (dataurl) => {
    var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
};
//将blob转换为file
export const blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
};

// qq浏览器需要特殊处理
export const isApp = () => {
    const u = navigator.userAgent.toLowerCase();
    let app =
        u.match(/MicroMessenger/i) == "micromessenger" ||
        u.match(/WeiBo/i) == "weibo" ||
        (u.indexOf("qq") !== -1 && u.indexOf("mqqbrowser") === -1) ||
        /alipay/gi.test(u) ||
        u.indexOf("dingtalk") !== -1;
    return app;
};


/**
 * @description: 获取文件名名字 .toLowerCase()
 * @param {*} str
 * @return {*}
 * @author: zhangle
 */
 export const getFileName = (str) => {
    let index = str.lastIndexOf('.')
    return str.slice(0, index)
}
/**
 * @description: 获取文件名后缀
 * @param {*} str
 * @return {*}
 * @author: zhangle
 */
 export const suffix = (str) => {
    let index = str.lastIndexOf('.')
    return str.slice(index + 1)
}
// 新开页跳转
export function hrefOpen(url) {
    var link = document.createElement('a')
    link.target = '_blank'
    link.href = url
    link.id = 'href'
    document.body.appendChild(link)
    link.click()
}
export function exportBlob(name, blobRes, callback) {
    let date = new Date()
    let y = date.getFullYear().toString()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? '0' + d : d

    const blob = new Blob([blobRes]);
    const fileName = name + "_" + y + m + d + ".csv";
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href);
    document.body.removeChild(elink);
    callback && callback()
}
  /**
 * @description: 登录
 * @return {*}
 * @author: zhangle
 */
  export const gotoLogin = (arg) => {
    let obj = GetRequest()
    let params = Object.assign(obj, {
        redirectUrl: encodeURI(window.location.origin),
    });
    window.location.href = "/api/login?" + qs.stringify(params);
}

/**
 * @description: 下载文件
 * @return {*}
 * @author: zhangle
 */
export const downloadFile = (url) => {
    //下载文件
    if (!url) return
    let a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", true);
    // let clickEvent = document.createEvent("MouseEvents");
    // clickEvent.initEvent("click", true, true);
    // a.dispatchEvent(clickEvent);
    a.click()
}

/**
 * @description: 节流函数
 * @return {*}
 * @author: zhangle
 */
export const throttle = (fn, wait) => {
    var pre = Date.now();
    return function(){
        var context = this;
        var args = arguments;
        var now = Date.now();
        if( now - pre >= wait){
            fn.apply(context,args);
            pre = Date.now();
        }
    }
}

/**
 * @description: 异步打开
 * @param {url, setUrl} url跳转的url setUrl需要设置的url
 * @return {*}
 * @author: zhangle
 */
export const asyncWindowOpen = (url, setUrl) => {

    // var popUp = window.open(url);
    // function preventDialog () {
    //     setUrl = setUrl || 'https://ev.tsa.cn'
    //     if (document.getElementById('tsa-asyncWindowOpen')) {
    //         document.getElementById('tsa-asyncWindowOpen').style.display = 'block'
    //     } else {
    //         let el = document.createElement('div')
    //         el.setAttribute('class', 'tsa-asyncWindowOpen')
    //         el.setAttribute('id', 'tsa-asyncWindowOpen')
    //         el.innerHTML = '<div class="tsa-asyncWindowOpen-content">\
    //                             <div class="close">\
    //                                 <span class="tsa-icon-close"></span>\
    //                             </div>\
    //                             <div class="info">\
    //                                 <h3>提示</h3>\
    //                                 <p>您的取证系统弹出的窗口已被浏览器拦截，请设置浏览器允许（' + setUrl + '）弹出窗口或点击<a href="' + url + '" target="_blank">继续取证</a>。</p>\
    //                             </div>\
    //                             <div class="btnGroup">\
    //                                 <a href="' + url + '" target="_blank">继续取证</a>\
    //                             </div>\
    //                         </div>'
    //         document.body.appendChild(el)
    //         document.querySelector('#tsa-asyncWindowOpen .tsa-icon-close').onclick = function () {
    //             document.getElementById('tsa-asyncWindowOpen').style.display = 'none'
    //         }
    //     }
    // }
    // if (popUp == null || typeof (popUp) == 'undefined') {
    //     preventDialog()
    // } else {
    //     popUp.focus();
    // }
}

/**
 * 只能输入大于0的正整数（不能以0开头）
 * @param {string} value
 * @returns {string | number} 返回空字符或数字
 */
export function integerFn(value) {
    let reg = /[1-9]{1}[0-9]*$/;
    let strArray = value.split("");
    let newStrs = "";
    for (let i = 0; i < strArray.length; i++) {
        if (reg.test(strArray[i])) {
            newStrs += strArray[i];
        } else if (i > 0 && strArray[i] === "0") {
            newStrs += strArray[i];
        }
    }
    if (newStrs - 0 > 0) {
        return newStrs - 0;
    } else {
        return "";
    }
}

// 分享证据后缀删除
export function getShareFileName(name) {
    if (Store.state.routerInfo.routes.path === '/qlws') {
        return name
    } else if (name.lastIndexOf('.') >= 0) {
        return name.substring(0, name.lastIndexOf('.'))
    } else {
        return name
    }
}

// 手机type回显
export function qlwsEviName(value) {
    return value === '1'
        ? 'GUARD_TAKE_PHOTO'
        : value === '2'
            ? 'GUARD_RECORD_VIDEO'
            : value === '3'
                ? 'GUARD_RECORD_AUDIO'
                : value === '4'
                    ? 'GUARD_EVIDENCE_WEBPAGE'
                    : value === '5'
                        ? 'GUARD_RECORD_SCREEN'
                        : ''
}

// 回显取证名称 类型
export function accountLabel(datas, value, isDetail = false){
    var actions = []
    Object.keys(datas).some((key) => {
        if (datas[key].value === value) {
            actions.push(datas[key].name)
            return true
        }
    })
    return actions.join('')
}

//将文件byte转对应大小
export function fileSize(value) {
    let size=value
    let num = 1024.00; //byte
    if (!size)
        return "";
    if (size < num)
        return size + "B";
    if (size < Math.pow(num, 2))
        return (size / num).toFixed(2) + "K"; //kb
    if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + "M"; //M
    if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
    return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
}


// 根据文件路径生成面包屑导航
export function generateCrumbsListByPath (fullPath, hasSubAccount, customName, customLink = '/', omit=false) {
    // console.log(fullPath)
    let array = fullPath.split('/')
    console.log({
        hasSubAccount,
        array
    })
    let crumbsList = []
    if (hasSubAccount) {
        array.forEach((item, index) => {
            if (index === 0) {
                crumbsList.push({
                    name: '',
                    path: ''
                })
                crumbsList.push({
                    // name: omit && customName.length > 10 ? customName.slice(0, 10) + '...' : customName,
                    name: customName,
                    limited: true,
                    limitedWidth: 290,
                    path: customLink,
                })
            } else if (index < array.length - 1) {
                crumbsList.push({
                    limited: true,
                    name: omit && item.length > 10 ? item.slice(0, 10) + '...' : item,
                    path: '/' + array.slice(1, index+1).join('/') + '/'
                })
            }
        })
    } else {
        array.forEach((item, index) => {
            if (index === 0) {
                crumbsList.push({
                    name: '',
                    path: customLink
                })
            } else if (index < array.length - 1) {
                crumbsList.push({
                    limited: true,
                    name: omit && item.length > 10 ? item.slice(0, 10) + '...' : item,
                    path: '/' + array.slice(1, index+1).join('/') + '/'
                })
            }
        })
    }
    return crumbsList
}

/**
 * 生成表格目录函数
 * 根据输入的路径字符串，将其分割为目录数组
 * @param {string} path - 需要分割的路径字符串
 */
export function generateTableDirectory (path, name) {
    let str = ''
    if (name) {
        str = name + path
    } else {
        str = path.slice(1)
    }
    // 去除路径构面最后一个/
    if (str.slice(-1) === '/') {
        str = str.slice(0, str.length-1)
    }
    return str
}
// 获取文件类型
export function generateTableIcon ({ name, evidenceName, folderStatus, dataBusinessType }, filed="name") {
    // 权利卫士的svg图标
    if (folderStatus === 1) {
        return 'folder'
    } else if (dataBusinessType === 22) {
        // 邮件认证专门的svg图标
        return 'email'
    } else if (dataBusinessType === 1 || dataBusinessType === 2) {
        // 电脑端-网页取证 电脑端-网页取证增强版
        return 'jpg'
    } else if (dataBusinessType === 4 || dataBusinessType === 5 || dataBusinessType === 6 || dataBusinessType === 7 || dataBusinessType === 8) {
        // 电脑端-录屏取证 电脑端-境外取证 电脑端-音视频自动取证 电脑端-直播自动取证 微信公众号取证
        return 'video'
    } else if (dataBusinessType === 9 || dataBusinessType === 11) {
        // 手机端-录像取证 手机端--录屏取证
        return 'video'
    } else if (dataBusinessType === 10) {
        // 手机端--录音取证
        return 'audio'
    } else if (dataBusinessType === 12 || dataBusinessType === 13) {
        // 手机端--网页取证 手机端--拍照取证
        return 'jpg'
    } else {
        // 其他情况
        let strArray = ''
        if (filed === 'evidenceName') {
            strArray = evidenceName.split('.')
        } else {
            strArray = name.split('.')
        }
        
        // 存在.
        if (strArray.length > 1) {
            let type = strArray[strArray.length - 1]
            type = type.toLowerCase()
            // 办公软件类型
            if (type === 'doc' || type === 'docx') {
                return 'word'
            } else if (type === 'xls' || type === 'xlsx') {
                return 'excel'
            } else if (type === 'ppt' || type === 'pptx') {
                return 'ppt'
            } else if (type === 'pdf') {
                return 'pdf'
            } else if (type === 'jpg' || type === 'jpeg') {
                // 图片类型
                return 'jpg'
            } else if (type === 'png') {
                // 图片类型
                return 'png'
            } else if (type === 'gif') {
                // 图片类型
                return 'picture'
            } else if (type === 'mp3' || type === 'wav' || type === 'm4a') {
                // 音频类型
                return 'audio'
            } else if (type === 'mp4' || type === 'avi' || type === 'rmvb' || type === 'mov' || type === 'webm') {
                // 视频类型
                return 'video'
            } else if (type === 'zip') {
                // 压缩包类型
                return 'zip'
            } else if (type === 'rar') {
                return 'rar'
            } else if (type === 'psd') {
                return 'ps'
            } else if (type === 'ai') {
                return 'ai'
            } else if (type === 'key') {
                return 'ketnoy'
            } else {
                // 其他类型
                return 'other'
            }
        } else {
            return 'other'
        }
    }
}

export function debounce(func, delay) {
    let timer;
    return function(...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    }
}
// 模糊搜索
export function fuzzySearch (value, evidenceSearchName) {
    if (!value) return ''
    evidenceSearchName = evidenceSearchName.trim()
    let index = value.indexOf(evidenceSearchName)
    if (index > -1) {
        let left = value.slice(0, index)
        let right = value.slice(index+evidenceSearchName.length)
        return left + `<span style="color: #409eff">${evidenceSearchName}</span>` + right
    } else {
        return value
    }
}

// 生成底部目录结构 以及name remark
export function generateDirectory (row, { evidenceSearchName, hasSubAccount, userInfo, page }) {
    if (page === 'search') {
        if (evidenceSearchName) {
            row.nameDisplay = row.name && fuzzySearch(row.name, evidenceSearchName)
            row.remarkDisplay = row.remark && fuzzySearch(row.remark, evidenceSearchName)
        } else {
            row.nameDisplay = row.name || ''
            row.remarkDisplay = row.remark || ''
        }
    }
    // 生成底部目录结构
    if (hasSubAccount) {
        if (userInfo.id == row.userId) {
            row.directory = generateTableDirectory(row.path, '我的证据文件夹')
        } else {
            let name = ''
            if (row.userStatus === 3) {
                name = `子账号（已注销_用户id：${row.userId}）的证据文件夹`
            } else {
                name = `子账号（${row.userAccountName}）的证据文件夹`
            }
            row.directory = generateTableDirectory(row.path, name)
        }
    } else {
        row.directory = generateTableDirectory(row.path, '我的证据文件夹')
    }
    return row
}

export const fileLinkToStreamDownload = (url, fileName) => {
    let link = document.createElement("a");
    link.style.display = "none";
    // link.target = "_blank";
    link.href = url;
    link.download = fileName;
    console.log(fileName)
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // }
};

export const sleep = (delay = 1000) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve()
        }, delay)
    })
}

export function isPCBrowser() {
  const ua = getUA();
  const mobilePattern = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
  return !mobilePattern.test(ua);
}

//根据指定字符串来匹配模板，返回匹配字符串两边的字符串的list
export function splitByKeyword(template, keyword) {
    if (!template || !keyword) return []
    const results = []
    let index = template.indexOf(keyword)
    while (index !== -1) {
        results.push({
            before: template.slice(0, index),
            keyword: keyword,
            after: template.slice(index + keyword.length)
        })
        index = template.indexOf(keyword, index + keyword.length)
    }
    return results
}